module.exports = __webpack_public_path__ + "static/media/AudioSwitchBtn_1K_white3.e552656d.svg";